export enum AuthCredentialType {
  AuthorizationCode = 'authorization_code',
  GoogleIdToken = 'google_id_token',
}
